/**
 * WindowsManager serves as a collector of active MessageWindows on the screen
 * 
 * @author Vladimir Dosen <vlada.dosen@gmail.com>
 * 
 * @returns {WindowsManager}
 */


var WindowsManager = function() {
  
    var windows             =   [];
    var current_window      =   null;
    
    this.addWindow = function(w) {
        windows.push(w.setManager(this));
        if(current_window === null) {
            this.setCurrentWindow(w);
        }
        return this;
    };
    this.getWindows = function() {
        return windows;
    };
    this.setCurrentWindow = function(cw) {
        current_window = cw;
        return this;
    };
    this.getCurrentWindow = function() {
        return current_window;
    };
    this.getWindowById = function(id) {
        for(var v in this.getWindows()) {
            if(this.getWindows()[v].getId() === id) {
                return this.getWindows()[v];
            }
        }
        return false;
    };
    this.showWindowById = function(id) {
        for(var v in this.getWindows()) {
            if(this.getWindows()[v].getId() === id) {
                this.setCurrentWindow(this.getWindows()[v]);
                this.getCurrentWindow().getStrategy().show();
                return true;
            }
        }
        return false;
    };

    
    this.next = function() {
        if(typeof this.getWindows()[this.getCurrentWindow().getId() + 1] !== "undefined") {
            this.setCurrentWindow(this.getWindows()[this.getCurrentWindow().getId() + 1]);
            this.getCurrentWindow().getStrategy().show();
            return true;
        }
        return false;
    };
    this.prev = function() {
        if(typeof this.getWindows()[this.getCurrentWindow().getId() - 1] !== "undefined") {
            this.setCurrentWindow(this.getWindows()[this.getCurrentWindow().getId() - 1]);
            this.getCurrentWindow().getStrategy().show();
            return true;
        }
        return false;
    };
    
    this.bindToEvents = function() {
        var self = this;
        var nextProcess = function() {
            self.next();
        };
        var prevProcess = function() {
            self.prev();
        };
        jQuery(document).bind('winman:next',  nextProcess);
        jQuery(document).bind('winman:prev',  prevProcess);
    };
    
    // auto-function
    this.engage = function() {
        this.bindToEvents();
    }.call(this);
    
    
};